import React, { useState } from "react";
import { Col, Row, Badge, Button, Modal } from "react-bootstrap";

import SplitNumber from "../../../components/SplitNumber";
import _ from "lodash";
import { IconTooman } from "../../../../assets/icons";

function WithdrowItem(props) {
  // let variantColor = "secondary";
  // if (props.ItemStatusType == true)
  //     variantColor = "success";
  // else if (props.ItemStatusType == false)
  //     variantColor = "danger";
  const setColor = (type) => {
    switch (type) {
      case "جدید":
        return "text-primary";
      case "رد_شده":
        return "text-danger";
      case "انجام_شد":
        return "text-success";
      case "درحال_پیگیری":
        return "text-warning";
      default:
        return "text-dark";
    }
  };
  const setBgColor = (type) => {
    switch (type) {
      case "جدید":
        return "#002270";
      case "رد_شده":
        return "#f80248";
      case "انجام_شد":
        return "#09a463";
      case "درحال_پیگیری":
        return "#ffc107";
      default:
        return "#212529";
    }
  };
  const [showModalDescription, setShowModalDescription] = useState(false);
  const handleShowModalDescription = () => setShowModalDescription(true);
  const handleCloseModalDescription = () => setShowModalDescription(false);
  return (
    <>
      <Col xs={12} lg={4} className="mt-3 mt-md-4 ">
        <div
          className="bg-white shadow-sm rounded-4 p-3 h-100"
          style={{ borderRight: `5px solid ${setBgColor(props.ItemStatus)}` }}
        >
          <Row className="my-2">
            <Col xs="auto" className="pe-0 text-muted">
              مبلغ
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg fw-bold">
              <SplitNumber number={props.ItemPrice}></SplitNumber>
              <span>
                <IconTooman fillColor="#000" style={{ marginTop: "-7px" }} />
              </span>
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="pe-0 text-muted">
              شماره کارت
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              {props.accountInfo}
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="pe-0 text-muted">
              نام بانک
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              {props.bankName}
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="pe-0 text-muted">
              صاحب حساب
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              {props.fullName}
            </Col>
          </Row>

          <Row className="my-2">
            <Col xs="auto" className="pe-0 text-muted">
              وضعیت
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              <span
                className={`fw-bold  fs-085  ${setColor(props.ItemStatus)}`}
              >
                {props.ItemStatus}
              </span>
            </Col>
          </Row>
          {!_.isEmpty(props.ItemDate) && (
            <Row className="my-2">
              <Col xs="auto" className="pe-0 text-muted">
                تاریخ
              </Col>
              <Col className="my-auto opacity-10">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="text-end text-dark medium-svg">
                {props.ItemDate}
              </Col>
            </Row>
          )}
          {!_.isEmpty(props.ItemCode) && (
            <Row className="my-2">
              <Col xs="auto" className="pe-0 text-muted">
                کد پیگیری
              </Col>
              <Col className="my-auto opacity-10">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="text-end text-dark medium-svg">
                {props.ItemCode}
              </Col>
            </Row>
          )}
          <Row>
            {!_.isEmpty(props.ItemDescription) ? (
              <Col xs={12} className="px-2 mt-2">
                <Button
                  variant="outline-primary"
                  className="fs-075 btn-sm rounded-2"
                  onClick={handleShowModalDescription}
                >
                  مشاهده بیشتر
                </Button>
                {/* <span className="fs-085 text-muted">توضیحات : </span>
              <span>{props.ItemDescription}</span> */}
              </Col>
            ) : (
              <></>
            )}
          </Row>
        </div>
      </Col>
      <Modal show={showModalDescription} onHide={handleCloseModalDescription}>
        <Modal.Header closeButton>
          <Modal.Title>درخواست برداشت وجه</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">مبلغ :</span>
              <span className="fw-bold">
                {" "}
                <SplitNumber number={props.ItemPrice} />
              </span>{" "}
              تومان
            </Col>
            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">شماره کارت :</span>
              <span> {props.accountInfo} </span>
            </Col>
            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">نام بانک :</span>
              <span> {props.bankName} </span>
            </Col>

            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">صاحب حساب :</span>
              <span> {props.fullName} </span>
            </Col>

            <Col xs={12} className="px-2">
              <div className="text-dark pt-2 mt-1 border-dashed-top"></div>
            </Col>

            <Col xs={12} className=" px-2 my-1">
              <span className="fs-085 text-muted">وضعیت : </span>
              <span
                className={`fw-bold  fs-085  ${setColor(props.ItemStatus)}`}
              >
                {props.ItemStatus}
              </span>
            </Col>
            {!_.isEmpty(props.ItemDate) && (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">تاریخ : </span>
                <span>{props.ItemDate}</span>
              </Col>
            )}
            {!_.isEmpty(props.ItemCode) && (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">کد پیگیری : </span>
                <span>{props.ItemCode}</span>
              </Col>
            )}
            {!_.isEmpty(props.ItemDescription) && (
              <Col xs={12} className="px-2">
                <span className="fs-085 text-muted">توضیحات : </span>
                <span>{props.ItemDescription}</span>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="btn-sm px-3"
            onClick={handleCloseModalDescription}
          >
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default WithdrowItem;
